import React, { useEffect, useState } from "react";
import MainPagetitle from "../../../layouts/MainPagetitle";
import DigitalLeads from "./digitalLeads/digitalLeads";
import OfflineLeads from "./offlineLeads/offlineLeads";
import OverallLeads from "./overallLeads/overallLeads";

const MyLeads = (props) => {
  const isAdmin = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  const isConnector =
    props?.$store?.user?.role === _enum.ROUTE_PERSONAS.connector;
  const isPanVerified = props.$store?.user?.is_pan_code_verified;
  const isAadharVerified = props.$store?.user?.is_aadhar_verified;
  const is_agreement_signed = props.$store?.user?.is_agreement_signed;
  const [activeKey, setActiveKey] = useState("digitalleads");

  const filterTabData = [
    // {
    //   key: "overallleads",
    //   name: "Overall Leads",
    // },
    {
      key: "digitalleads",
      name: "Digital Applications",
    },
    {
      key: "offlineleads",
      name: "Overall Applications",
    },
  ];

  const handleSelect = (e, key) => {
    console.log({ key });
    setActiveKey(key);
    navigate(`/app/businesstobusiness?activetab=${key}`);
  };

  useEffect(() => {
    // PERSIST ACTIVE TAB ON PAGE RE-LOAD
    let paramsActiveTab = props.urlparams.params.activetab;
    if (paramsActiveTab) {
      setActiveKey(paramsActiveTab);
    }
    if (isConnector) {
      if (!isPanVerified || !isAadharVerified || !is_agreement_signed) {
        swal2
          .fire({
            title: "Account Verification Pending",
            text: "Please complete your profile",
            icon: "info",
            iconColor: "#234C9B",
          })
          .then((result) => {
            if (result.isConfirmed) {
              props.navigate("/app/myprofile");
            }
          });
      }
    }

    // scroll page to top
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MainPagetitle
        mainTitle={isAdmin ? "B2B Leads" : "Digital Applications"}
        pageTitle="B2B Leads"
        parentTitle="Home"
        pageIcon={
          isAdmin ? imagepaths.AdminLeadsIconActive : imagepaths.LeadsIconActive
        }
      />
      {!isConnector ||
      (isPanVerified && isAadharVerified && is_agreement_signed) ? (
        <div className="container-fluid position-relative">
          {isAdmin ? (
            <>
              <div className="filter_tab_container ps-3">
                {filterTabData?.map((btn) => {
                  return (
                    <>
                      <button
                        type="button"
                        id={btn.key}
                        className={Object.className({
                          active: activeKey === btn.key,
                        })}
                        onClick={(...args) => handleSelect(...args, btn.key)}
                      >
                        {btn.name}
                      </button>
                    </>
                  );
                })}
              </div>
              <div className="filter_tab_pane">
                {/* {activeKey === "overallleads" && <OverallLeads />} */}
                {activeKey === "digitalleads" && <DigitalLeads />}
                {activeKey === "offlineleads" && <OfflineLeads />}
              </div>
            </>
          ) : (
            <>
              <div className="filter_tab_pane">
                {activeKey === "digitalleads" && <DigitalLeads />}
              </div>
            </>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
export default constore(MyLeads);
